<template>
  <div>
    <DxDataGrid ref="dataGrid" :allowColumnReordering="true" :data-source="{
      store: dsActivitati,
      filter: gridFilter
    }" :allowColumnResizing="true" key-expr="ID" :columnAutoWidth="false" :columnResizingMode="'nextColumn'"
      :show-borders="true" :syncLookupFilterValues="false" :filter-sync-enabled="true" :show-row-lines="true"
      :show-column-lines="false" :allowMerging="'Cells'" height="100%" class="grid theme-dependent"
      @exporting="onExporting" @editing-start="onEditingStart">
      <DxSelection mode="single" />
      <DxScrolling :mode="'virtual'" />
      <DxColumnChooser :enabled="true" :allow-search="true" title="Selector coloane" />
      <DxPaging :page-size="20" />
      <DxSorting mode="multiple" />
      <DxHeaderFilter :visible="false" />
      <DxFilterRow :visible="true" />
      <DxLoadPanel :show-pane="false" />
      <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
      <DxGridToolbar>
        <DxGridToolbarItem location="before">
          <template #default>
            <button class="continue-application" @click="goToActivities">
              <div>
                <div class="folder">
                  <div class="top">
                    <svg viewBox="0 0 24 27">
                      <path d="M0 0h24v27H0z"></path>
                    </svg>
                  </div>
                  <div class="paper"></div>
                </div>
                <div class="pencil"></div>
              </div>
              Vezi pagina de activități
            </button>
          </template>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <DxButton icon="plus" type="success" @click="onAddClick" :disabled="isLocked" hint="Adauga Activitate" />
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <DxButton icon="refresh" @click="onRefreshClick" hint="Reimprospateaza" />
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <div class="separator"></div>
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem name="exportButton" hint="Exporta" />
        <DxGridToolbarItem location="after" locate-in-menu="auto">
          <div>
            <div class="separator"></div>
          </div>
        </DxGridToolbarItem>
        <DxGridToolbarItem name="columnChooserButton" locate-in-menu="auto" hint="Alege Coloanele" />
        <DxGridToolbarItem name="searchPanel" locate-in-menu="auto" />
      </DxGridToolbar>
      <DxTexts group-continued-message="Continuat de pe pagina anterioara"
        group-continues-message="Continuat pe pagina urmatoare" />
      <DxEditing :allowUpdating="!isLocked" :allowDeleting="!isLocked" mode="popup" @click="onRowRemoving">
        <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="800" :height="650">
          <DxToolbarItem :template="customTitleTemplate" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="successButtonOptions" />
          <DxToolbarItem toolbar="bottom" widget="dxButton" location="after" :options="dangerButtonOptions" />
        </DxPopup>
        <DxFormGrid :col-count="1">
          <DxFormItemGrid :col-count="3" item-type="group">

            <DxFormItemGrid data-field="TipActivitateID" :col-span="3" :col-count="3"
              :label="{ text: 'Tip Activitate' }" editor-type="dxDropDownBox" :editor-options="{
                dataSource: dsTipActivitati,
                valueExpr: 'ID',
                displayExpr: displayTipActivitate,
                contentTemplate: 'content',
                showClearButton: true
              }" />
            <DxFormItemGrid dataField="Cost" editorType="dxNumberBox" :editor-options="{
              format: '#0.00',
              showSpinButtons: true,
            }" />
            <DxFormItemGrid :label="{ text: 'Valută' }">
              <DxDropDownBox v-model:opened="isValuteGridBoxOpened" :data-source="valutaSelectat"
                v-model:value="sValuta" display-expr="Simbol" value-expr="Id" :show-clear-button="true"
                placeholder="RON">
                <template #content="{ data }">
                  <DxDataGrid :data-source="dsValuta" v-model:value="sValuta" :columns="['Simbol']"
                    :hover-state-enabled="true" height="100%" @selection-changed="onValueSelectedValuta($event)">
                    <DxSelection mode="single" />
                    <DxPaging :enabled="true" :page-size="5" />
                    <DxFilterRow :visible="true" />
                    <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                  </DxDataGrid>
                </template>
              </DxDropDownBox>
            </DxFormItemGrid>

            <DxFormItemGrid dataField="Data" editorType="dxDateBox"
              :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }" />
            <DxFormItem dataField="Descriere" :col-count="3" :col-span="3" :editor-options="{ height: 100 }"
              editorType="dxTextArea" />
            <DxFormItemGrid item-type="simple" :col-span="3">
              <template #default>
                <div class="edit-file-card">
                  <div class="edit-file-title">Documente / Fișiere</div>

                  <div v-if="isEditFilesLoading" class="edit-file-muted">Se încarcă...</div>

                  <div v-else-if="editActivityFiles.length === 0" class="edit-file-muted">
                    Nu există fișiere atașate.
                  </div>

                  <div v-else class="files-list">
                    <div class="file-row" v-for="f in editActivityFiles" :key="f.ID"
                      :class="{ active: selectedEditFile?.ID === f.ID }" @click="selectFileForReplace(f)">
                      <div class="file-name">{{ f.FileName }}</div>

                      <div class="file-actions">
                        <!-- Download (HTML button styled like DevExtreme) -->
                        <button type="button" class="dx-button dx-button-mode-text dx-button-normal dx-widget"
                          title="Descarcă" @click.stop="onDownloadFile(f)">
                          <span class="dx-button-content">
                            <i class="dx-icon dx-icon-download"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Replace -->
                  <div v-if="editActivityFiles.length > 0" class="replace-block">
                    <div class="replace-hint">
                      Se va înlocui: <b>{{ selectedEditFile?.FileName || '-' }}</b>
                    </div>

                    <input type="file" ref="editFileInput" style="display:none" @change="onReplaceFileSelectedCustom" />

                    <div class="replace-row">
                      <span v-if="editReplaceFile" class="replace-new">
                        Nou: {{ editReplaceFile.name }}
                      </span>
                      <span v-else class="replace-none">
                        (Niciun fișier nou selectat)
                      </span>

                      <!-- Choose file -->
                      <button type="button" class="dx-button dx-button-mode-outlined dx-button-normal dx-widget"
                        :disabled="isLocked" @click="triggerFileSelect">
                        <span class="dx-button-content">
                          <i class="dx-icon dx-icon-upload"></i>
                          <span class="dx-button-text">Alege alt fișier</span>
                        </span>
                      </button>
                    </div>

                    <div class="replace-actions">
                      <!-- Replace -->
                      <button type="button" class="dx-button dx-button-mode-outlined dx-button-success dx-widget"
                        :disabled="!selectedEditFile?.ID || !editReplaceFile" @click="replaceCurrentFile">
                        <span class="dx-button-content">
                          <span class="dx-button-text">Înlocuiește</span>
                        </span>
                      </button>
                    </div>
                  </div>

                  <!-- Add New Files Section (As requested by user) -->
                  <div class="add-new-files-block"
                    style="margin-top: 20px; border-top: 1px dashed #e2e8f0; padding-top: 15px;">
                    <div class="edit-file-title" style="margin-bottom: 10px;">Adaugă fișiere noi</div>

                    <input type="file" multiple id="editActivityInputHidden" style="display:none"
                      @change="onEditFileSelectedCustom" />

                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <div class="selected-files-list" style="flex:1;">
                        <div v-if="selectedFilesEdit && selectedFilesEdit.length > 0">
                          <div v-for="(file, index) in selectedFilesEdit" :key="index"
                            style="display:flex; align-items:center; gap:6px; font-size:13px; font-weight:600; color:#059669; margin-bottom:4px;">
                            <span>{{ file.name }}</span>
                            <span class="dx-icon-remove" style="cursor:pointer; color:#ef4444;"
                              @click="removeEditFile(index)" title="Șterge fișier"></span>
                          </div>
                        </div>
                        <span v-else class="edit-file-muted" style="font-size:12px;">
                          (Niciun fișier nou selectat)
                        </span>
                      </div>

                      <button type="button" class="dx-button dx-button-mode-outlined dx-button-normal dx-widget"
                        :disabled="isLocked" @click="triggerEditFileAdd">
                        <span class="dx-button-content">
                          <i class="dx-icon dx-icon-upload"></i>
                          <span class="dx-button-text">Alege fișiere</span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </DxFormItemGrid>
          </DxFormItemGrid>


        </DxFormGrid>

      </DxEditing>

      <DxStateStoring :enabled="true" :filterValue="false" :savingTimeout="100" storage-key="gridCardActivitatiState" />
      <DxColumn data-field="TipActivitate.Nume" caption="Tip Activitate" />
      <DxColumn data-field="TipActivitateID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'accountCellEditorTipActivitate'" />
      <template #accountCellEditorTipActivitate="{ data }">
        <DxDropDownBox :data-source="dsTipActivitati" value-expr="ID" :display-expr="displayTipActivitate"
          :value="data.value" v-model:opened="isActivityDdbOpen" :show-clear-button="true">
          <template #content>
            <DxDataGrid :data-source="dsTipActivitati" key-expr="ID" :columns="['Nume']" height="100%"
              @selection-changed="e => {
                const id = e.selectedRowKeys?.[0] ?? null;
                data.setValue(id);
                isActivityDdbOpen = false;
              }">
              <DxSelection mode="single" />
            </DxDataGrid>
          </template>
        </DxDropDownBox>
      </template>
      <DxColumn data-field="Descriere" />
      <DxColumn data-field="Sale.Titlu" caption="Oportunitate" :visible="false" />
      <DxColumn data-field="Account.Nume" caption="Partener" />
      <DxColumn data-field="AccountID" :visible="false" :show-in-column-chooser="false"
        :edit-cell-template="'accountCellEditor'" />
      <template #accountCellEditor="{ data }">
        <DxDropDownBox :data-source="dsParteneri" value-expr="ID" :display-expr="displayCompanie" :value="data.value"
          v-model:opened="isAccountDdbOpen" :show-clear-button="true">
          <template #content>
            <DxDataGrid :data-source="dsParteneri" key-expr="ID" :columns="['Nume']" height="100%" @selection-changed="e => {
              const id = e.selectedRowKeys?.[0] ?? null;
              data.setValue(id);
              isAccountDdbOpen = false;
            }">
              <DxSelection mode="single" />
            </DxDataGrid>
          </template>
        </DxDropDownBox>
      </template>

      <DxColumn data-field="NumeFisier" :visible="false" caption="Nume Fișier" />
      <DxColumn data-field="Path" :visible="false" caption="Cale" />
      <DxColumn data-field="Globala" :visible="false" caption="Globală" />
      <DxColumn data-field="Cost" :visible="false" caption="Cost" />
      <DxColumn data-field="Durata" :visible="false" caption="Durată" />
      <DxColumn data-field="Valuta.Simbol" :visible="false" caption="Valuta" />
      <DxColumn data-field="Curs" :visible="false" caption="Curs" />
      <DxColumn data-field="Data" />
      <DxColumn data-field="Owner" caption="Responsabil" />
      <DxColumn type="buttons" :visible-index="9999" :allow-reordering="false" :allow-resizing="false" width="90"
        :buttons="[
          {
            hint: 'Vezi detalii',
            icon: 'info',
            onClick: onViewDetails
          },
          'edit',
          'delete'
        ]" />
    </DxDataGrid>
    <DxPopupAdd v-model:visible="isActivityDetailsVisible" :drag-enabled="false" :hide-on-outside-click="true"
      :show-close-button="true" :width="750" :height="700">
      <template #title>
        <div class="popup-header popup-header--activity">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-task"></span>
            <div class="popup-header-texts">

              <div class="popup-header-title">{{ selectedActivity.TipActivitate || 'Activitate CRM' }}</div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span :class="['status-chip', selectedActivity.Globala ? 'status-chip--global' : 'status-chip--local']">
              {{ selectedActivity.Globala ? 'Globală' : 'Locală' }}
            </span>
          </div>
        </div>
      </template>

      <DxScrollView width="100%" height="100%" class="details-scroll-view">
        <div class="details-container">
          <!-- Quick Stats Row -->
          <div class="stats-grid">
            <div class="stat-card stat-card--cost">
              <div class="stat-icon dx-icon-money"></div>
              <div class="stat-content">
                <div class="stat-label">Cost Estimativ</div>
                <div class="stat-value">{{ formatCurrency(selectedActivity.Cost, selectedActivity.Valuta) }}</div>
              </div>
            </div>
            <!-- <div class="stat-card stat-card--duration">
              <div class="stat-icon dx-icon-clock"></div>
              <div class="stat-content">
                <div class="stat-label">Durată</div>
                <div class="stat-value">{{ selectedActivity.Durata || 0 }} ore</div>
              </div>
            </div> -->
            <div class="stat-card stat-card--date">
              <div class="stat-icon dx-icon-event"></div>
              <div class="stat-content">
                <div class="stat-label">Data Planificată</div>
                <div class="stat-value">{{ formatDate(selectedActivity.Data) }}</div>
              </div>
            </div>
          </div>

          <!-- Main Info Grid -->
          <div class="info-sections-grid">
            <!-- Left Column: Context -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-link section-icon"></span>
                  <span>Context Activitate</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Partener</label>
                    <div class="value">{{ selectedActivity.Account || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Oportunitate Asociată</label>
                    <div class="value highlight">{{ selectedActivity.Sale || '-' }}</div>
                  </div>
                  <div class="info-item">
                    <label>Tip Activitate</label>
                    <div class="value">{{ selectedActivity.TipActivitate || '-' }}</div>
                  </div>
                </div>
              </div>

              <div class="info-section-card">

                <div class="info-section-card">
                  <div class="section-header">
                    <span class="dx-icon-floppy section-icon"></span>
                    <span>Documente / Fișiere</span>
                  </div>

                  <div class="info-list">
                    <div v-if="isFilesLoading" class="info-item">
                      <div class="value">Se încarcă fișierele...</div>
                    </div>

                    <div v-else-if="activityFiles.length === 0" class="info-item">
                      <div class="value">Nu există fișiere atașate.</div>
                    </div>

                    <div v-else class="info-item">
                      <label>Fișiere</label>

                      <div class="files-list">
                        <div class="file-row" v-for="f in activityFiles" :key="f.ID">
                          <div class="file-name">{{ f.FileName }}</div>

                          <div class="file-actions">
                            <DxButton icon="download" styling-mode="text" hint="Descarcă"
                              @click="() => onDownloadFile(f)" />
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </div>

            <!-- Right Column: Details -->
            <div class="info-column">
              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-doc section-icon"></span>
                  <span>Descriere & Note</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Descriere Detaliată</label>
                    <div class="value multiline">{{ selectedActivity.Descriere || '-' }}</div>
                  </div>
                  <!-- <div class="info-item">
                    <label>Vizibilitate</label>
                    <div class="value">{{ selectedActivity.Globala || '-' }}</div>
                  </div> -->
                </div>
              </div>

              <div class="info-section-card">
                <div class="section-header">
                  <span class="dx-icon-info section-icon"></span>
                  <span>Informații Financiare</span>
                </div>
                <div class="info-list">
                  <div class="info-item">
                    <label>Valoare (Cost)</label>
                    <div class="value success">{{ formatCurrency(selectedActivity.Cost, selectedActivity.Valuta) }}
                    </div>
                  </div>
                  <div class="info-item">
                    <label>Curs Valutar</label>
                    <div class="value">{{ selectedActivity.Curs || '1.0000' }}</div>
                  </div>
                  <!-- <div class="info-item">
                    <label>Total Ore</label>
                    <div class="value highlight">{{ selectedActivity.Durata || '0' }} ore de lucru</div>
                  </div> -->
                </div>
              </div>
            </div>
          </div>

          <!-- Bottom Meta Section -->
          <div class="system-meta-card">
            <div class="meta-row">
              <div class="meta-item">
                <span class="dx-icon-user meta-icon"></span>
                <span>Creat de <strong>{{ selectedActivity.UserCreat || 'Sistem' }}</strong> la {{
                  formatDate(selectedActivity.DataCreat, true) }}</span>
              </div>
            </div>
          </div>
        </div>
      </DxScrollView>
    </DxPopupAdd>
    <DxPopupAdd v-model:visible="isModalVisible" :closeOnOutsideClick="false" :showCloseButton="false" :showTitle="true"
      :width="700" :height="590">
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare activitate</div>
              <div class="popup-header-subtitle">
                Completează informațiile în pașii de mai jos
              </div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">
              Nouă
            </span>
          </div>
        </div>
      </template>
      <div ref="popupBody" class="popup-body-simple popup-body-modern">
        <div class="form-content form-content-modern">

          <DxForm :formData="formData">
            <DxFormItem :col-span="3" :col-count="3" item-type="group">

              <DxFormItem :label="{ text: 'Tip Activitate' }" :col-count="3" :col-span="3">
                <DxRequiredRule message="Câmpul 'Tip Activitate' este obligatoriu" />
                <DxDropDownBox v-model:opened="isTipActivitateGridBoxOpened" :data-source="tipActivitateSelectat"
                  v-model:value="sTipActivitate" :show-clear-button="true" display-expr="Nume" value-expr="ID">

                  <template #content="{ data }">
                    <DxDataGrid :data-source="dsTipActivitati" v-model:value="sTipActivitate" :columns="['Nume']"
                      :hover-state-enabled="true" height="100%"
                      @selection-changed="onValueSelectedTipActivitate($event)">
                      <DxSelection mode="single" />
                      <DxScrolling mode="virtual" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>

              <DxFormItem dataField="Cost" editorType="dxNumberBox" :editor-options="{
                format: '#0.00',
                showSpinButtons: true,
              }" />

              <DxFormItem :label="{ text: 'Valuta' }">
                <DxDropDownBox v-model:opened="isValuteGridBoxOpened" :data-source="valutaSelectat"
                  v-model:value="sValuta" :show-clear-button="true" display-expr="Simbol" value-expr="Id"
                  placeholder="RON">

                  <template #content="{ data }">
                    <DxDataGrid :data-source="dsValuta" v-model:value="sValuta" :columns="['Simbol']"
                      :hover-state-enabled="true" height="100%" @selection-changed="onValueSelectedValuta($event)">
                      <DxSelection mode="single" />
                      <DxPaging :enabled="true" :page-size="5" />
                      <DxFilterRow :visible="true" />
                      <DxSearchPanel :visible="true" placeholder="Cauta ..." />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </DxFormItem>


              <DxFormItem dataField="Data" editorType="dxDateBox"
                :editor-options="{ displayFormat: 'dd/MM/yyyy', dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ssZ' }" />
              <DxFormItem dataField="Descriere" :col-count="3" :col-span="3" :editor-options="{ height: 100 }"
                editorType="dxTextArea">
                <DxRequiredRule message="Câmpul 'Descriere' este obligatoriu" />
              </DxFormItem>
              <DxFormItem :col-span="3">
                <template #default>
                  <div style="display:flex; flex-direction:column; gap:8px;">
                    <!-- Custom File Input for ADD -->
                    <!-- Added 'multiple' attribute -->
                    <input type="file" multiple ref="addFileInput" id="addActivityInputHidden" style="display: none"
                      @change="onAddFileSelectedCustom" />

                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <div class="selected-files-list" style="flex:1;">
                        <div v-if="selectedFiles && selectedFiles.length > 0">
                          <div v-for="(file, index) in selectedFiles" :key="index"
                            style="display:flex; align-items:center; gap:6px; font-size:13px; font-weight:600; color:#059669; margin-bottom:4px;">
                            <span>{{ file.name }}</span>
                            <span class="dx-icon-remove" style="cursor:pointer; color:#ef4444;"
                              @click="removeFile(index)" title="Șterge fișier"></span>
                          </div>
                        </div>
                        <span v-else style="font-size:12px; color:#94a3b8;">
                          (Niciun fișier selectat)
                        </span>
                      </div>

                      <DxButton text="Alege fișiere" icon="upload" styling-mode="outlined" type="default"
                        @click="triggerAddFileSelect" :disabled="isLocked" />
                    </div>
                  </div>
                </template>
              </DxFormItem>
            </DxFormItem>

          </DxForm>
        </div>
        <div class="form-footer footer-fixed footer-modern">
          <div class="footer-left">
            <DxButton text="Programează activitate următoare" type="success" width="auto" height="32"
              styling-mode="outlined" :use-submit-behavior="false" @click="() => onSaveAdd(true)"
              :disabled="isLocked" />
          </div>
          <div class="footer-right">
            <DxButton text="Salvează" type="success" width="120" height="32" styling-mode="outlined"
              @click="() => onSaveAdd(false)" :disabled="isLocked" />
            <DxButton text="Închide" type="danger" width="120" height="32" styling-mode="outlined" @click="onCancel" />
          </div>
        </div>
      </div>
    </DxPopupAdd>
  </div>
</template>
<script lang="ts">

import DxValidator, { DxRequiredRule, DxCustomRule } from 'devextreme-vue/validator'
import DxDropDownButton, { DxDropDownButtonTypes } from 'devextreme-vue/drop-down-button';
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd from 'devextreme-vue/popup';
import { DxSimpleItem, DxLabel } from 'devextreme-vue/form';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DxForm, DxItem as DxFormItem } from 'devextreme-vue/form';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import notify from 'devextreme/ui/notify';
import JwtServices from '@/services/JwtServices';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import CrmActivitati from '@/services/Comercial/CrmActivitati';
import DataSource from "devextreme/data/data_source";
import DxDropDownBox from "devextreme-vue/drop-down-box";
import { locale, loadMessages } from 'devextreme/localization';
import DxFileUploader from "devextreme-vue/file-uploader";

import {
  DxItem as DxGridToolbarItem,
  DxLookup,
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar as DxGridToolbar,
  DxEditing,
  DxColumnChooser,
  DxGrouping,
  DxGroupPanel,
  DxTexts,
  DxExport,
  DxSearchPanel,
  DxMasterDetail,
  DxPopup,
  DxToolbarItem,
  DxForm as DxFormGrid,
  DxItem as DxFormItemGrid,
  DxScrolling,
  DxHeaderFilter
} from 'devextreme-vue/data-grid';

export default defineComponent({
  components: {
    DxGridToolbar,
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxStateStoring,
    DxLoadPanel,
    DxPaging,
    DxButton,
    DxEditing,
    DxPopupAdd,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxScrollView,
    DxLookup,
    DxColumnChooser,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport,
    DxSearchPanel,
    DxMasterDetail,
    DxPopup,
    DxToolbarItem,
    DxFormGrid,
    DxGridToolbarItem,
    DxScrolling,
    DxHeaderFilter,
    DxDropDownButton,
    DxFormItem,
    DxDropDownBox,
    DxFormItemGrid,
    DxRequiredRule,
    DxFileUploader
  },
  props: {
    opportunityId: {
      type: String,
      required: false
    },
    accountId: {
      type: String,
      required: false
    },
    opportunityData: {
      type: Object,
      required: false
    },
    isLocked: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      Username: "",
      partenerSelectat: [],
      isParteneriGridBoxOpened: false,
      sPartener: null,

      isOportunitateGridBoxOpened: false,
      sOportunitate: null,
      oportunitateSelectat: [],

      tipActivitateSelectat: [],
      isTipActivitateGridBoxOpened: false,
      sTipActivitate: null,

      valutaSelectat: [],
      isValuteGridBoxOpened: false,
      sValuta: null,
      dsTipActivitati: {} as ODataStore,
      dsActivitati: {} as ODataStore,
      dsContacts: {} as ODataStore,
      dsParteneri: {} as ODataStore,
      dsValuta: {} as ODataStore,
      dsSales: {} as ODataStore,
      isModalVisible: false,
      isActivityDetailsVisible: false,
      isPanelOpened: ref(false),
      dataGrid: ref<DxDataGrid | null>(null),
      isAccountDdbOpen: false as boolean,
      isActivityDdbOpen: false as boolean,
      deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
      editActivityFiles: [] as any[],
      isEditFilesLoading: false,

      selectedEditFile: null as any | null,   // fișierul din listă pe care îl înlocuiești
      editReplaceFile: null as File | null,

      currentEditingActivityId: null as string | null,

      selectedFile: null as File | null,
      editFileInfo: null as any | null,       // fișierul curent (primul)

      activityFiles: [],
      isFilesLoading: false,

      selectedActivity: {
        SaleID: null,
        AccountID: null,
        TipActivitateID: null,
        Descriere: '',
        NumeFisier: '',
        Path: '',
        DataCreat: null,
        UserCreat: '',
        Globala: '',
        Cost: null,
        Durata: null,
        ValutaID: null,
        Curs: null,
        Data: null,
        Account: '',
        Valuta: '',
        Sale: '',
        TipActivitate: ''
      },
      selectedFiles: [] as File[],
      isNextModalVisible: false,
      formData: {
        SaleID: null,
        AccountID: null,
        TipActivitateID: null,
        Descriere: '',
        NumeFisier: '',
        Path: '',
        DataCreat: null,
        UserCreat: '',
        Globala: '',
        Cost: null,
        Durata: null,
        ValutaID: null,
        Curs: null,
        Data: null,
        Account: '',
        Valuta: '',
        Sale: '',
        TipActivitate: ''
      },
      selectedFilesEdit: [] as File[],
    };
  },
  computed: {
    successButtonOptions(): any {
      return {
        type: 'success',
        stylingMode: 'outlined',
        text: 'Salvează',
        disabled: this.isLocked,
        onClick: () => {
          this.SaveEdit();
        },
      };
    },
    dangerButtonOptions(): any {
      return {
        type: 'danger',
        stylingMode: 'outlined',
        text: 'Închide',
        onClick: () => {
          this.onCancel();
        },
      };
    },
    customTitleTemplate() {
      return `
          <div class="popup-header" style="width: 800px; margin: -5px -20px 0 -20px; padding: 16px 24px; background: linear-gradient(90deg, #ff2c21, #ff6a4a); display: flex; align-items: center; gap: 16px;">
             <span class="dx-icon-edit" style="font-size: 24px; width: 30px; height: 40px; display: flex; align-items: center; justify-content: center; border-radius: 8px; color: white;"></span>
             <div style="display: flex; flex-direction: column; color: white;">
                <span style="font-size: 16px; font-weight: 700;">Editare Activitate existentă</span>
                <span style="font-size: 12px; opacity: 0.9;">Modifică detaliile activității selectate</span>
             </div>
          </div>
        `;
    },
    gridFilter() {
      if (this.opportunityId) {
        return ['SaleID', '=', this.opportunityId];
      }
      if (this.accountId) {
        return ['AccountID', '=', this.accountId];
      }
      return ['ID', '=', '00000000-0000-0000-0000-000000000000'];
    }
  },
  watch: {
    sOportunitate(newId) {
      if (newId) {
        this.dsSales.store().byKey(newId).then(x => {
          if (!x) return;
          x.Titlu = (x.Titlu ?? '(fara nume)');
          this.oportunitateSelectat = [x];
        });

      } else {
        this.oportunitateSelectat = [];
      }
    },
    sPartener(newId) {
      if (newId) {
        this.dsParteneri.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.partenerSelectat = [x];
        });
      } else {
        this.partenerSelectat = [];
      }
    },
    sTipActivitate(newId) {
      if (newId) {
        this.dsTipActivitati.store().byKey(newId).then(x => {
          if (!x) return;
          x.Nume = (x.Nume ?? '(fara nume)');
          this.tipActivitateSelectat = [x];
        });

      } else {
        this.tipActivitateSelectat = [];
      }
    },
    sValuta(newId) {
      if (newId) {
        this.dsValuta.store().byKey(newId).then(x => {
          if (!x) return;
          x.Simbol = (x.Simbol ?? '(fara nume)');
          this.valutaSelectat = [x];
        });

      } else {
        this.valutaSelectat = [];
      }
    },
  },
  methods: {


    onFileSelected(e: any) {
      const files = e?.value || [];
      this.selectedFile = files.length ? files[0] : null;

      // opțional: completezi automat NumeFisier în formData
      this.formData.NumeFisier = this.selectedFile ? this.selectedFile.name : '';
    },

    setDeleteConfirmationMessage() {
      const dataGrid = this.$refs.dataGrid?.instance;
      dataGrid.option('editing', {
        allowDeleting: !this.isLocked,
        allowUpdating: !this.isLocked,
        mode: 'popup',
        texts: {
          confirmDeleteMessage: this.deleteConfirmationMessage,
          confirmDeleteTitle: "Confirmare Ștergere",
        }
      });
    },
    createODataContext() {
      this.dsActivitati = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'CRM_Activitati',
        key: 'ID',
        keyType: "Guid",
        fieldTypes: {
          SaleID: 'Guid',
          AccountID: 'Guid',
          TipActivitateID: 'Guid',
          ValutaID: 'Guid'
        },
        version: 4,
        beforeSend: (e) => {
          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt"),
          };

          e.params.$expand = "Sale($select=Titlu),Account($select=Nume),TipActivitate($select=Nume),Valuta($select=Simbol)";

        }
      });
      this.dsSales = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_Sales',
          key: 'ID',
          keyType: "Guid",
          version: 4,
          fieldTypes: {
            ID: 'Guid'
          },

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Titlu',
        ],

      });
      this.dsParteneri = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'PAR_Parteneri',
          key: 'ID',
          keyType: "Guid",
          version: 4,
          fieldTypes: {
            ID: 'Guid'
          },

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });
      this.dsTipActivitati = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'CRM_CautareTipuriActivitati',
          key: 'ID',
          keyType: "Guid",
          version: 4,
          fieldTypes: {
            ID: 'Guid'
          },

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'ID',
          'Nume',
        ],

      });

      this.dsValuta = new DataSource({
        store: {
          type: 'odata',
          url: AppSetting.API_Url_ComercialOdata + 'ERP_Valute',
          key: 'Id',
          keyType: "Guid",
          version: 4,

          beforeSend: (e: any) => {

            e.headers = {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

            };
          }
        },
        select: [
          'Id',
          'Simbol',
        ],

      });
    },

    selectFileForReplace(f: any) {
      this.selectedEditFile = f;
      this.editReplaceFile = null; // ca să nu înlocuiești accidental alt fișier
    },

    triggerFileSelect() {
      (this.$refs.editFileInput as HTMLInputElement)?.click();
    },

    onReplaceFileSelectedCustom(e: any) {
      const file = e?.target?.files?.[0] || null;
      this.editReplaceFile = file;

      // reset input, ca să poți selecta același fișier de 2 ori
      e.target.value = "";
    },

    async replaceCurrentFile() {
      if (!this.selectedEditFile?.ID || !this.editReplaceFile) return;

      try {
        await CrmActivitati.replace(this.selectedEditFile.ID, this.editReplaceFile);
        notify("Fișier înlocuit.", "success", 1500);

        // reîncarci lista
        if (this.currentEditingActivityId) {
          await this.loadEditFiles(this.currentEditingActivityId);

          // reselectezi fișierul înlocuit (după ID)
          this.selectedEditFile =
            this.editActivityFiles.find(x => x.ID === this.selectedEditFile.ID) || this.editActivityFiles[0] || null;
        }

        this.editReplaceFile = null;
      } catch (err) {
        console.error(err);
        notify("Eroare la înlocuire fișier.", "error", 1500);
      }
    },

    displayCompanie(item) {
      return item ? (item.Nume || '(fără nume)') : '';
    },
    displayTipActivitate(item) {
      return item ? (item.Nume || '(fara nume)') : '';
    },
    toNullIfEmpty(val) {
      return val === '' || val === undefined || val === null ? null : val;
    },

    normalizeFormData(formData) {
      const cleaned = { ...formData };
      const dateFields = [
        'Data',
        'DataCreat',
      ];

      dateFields.forEach((field) => {
        const val = cleaned[field];
        cleaned[field] = this.toNullIfEmpty(val) !== null ? new Date(val) : null;
      });

      Object.keys(cleaned).forEach((key) => {
        cleaned[key] = this.toNullIfEmpty(cleaned[key]);
      });

      return cleaned;
    },

    goToActivities() {
      this.$router.push({ name: 'GridTabActivitati' });
    },

    async onSaveAdd(keepOpen = false) {
      if (this.isLocked) return;

      if (!this.formData.TipActivitateID) {
        notify('Completați câmpul obligatoriu "Tip Activitate"!', 'error', 1000);
        return;
      }

      if (!this.formData.Descriere || this.formData.Descriere.trim() === '') {
        notify('Completați câmpul obligatoriu "Descriere"!', 'error', 1000);
        return;
      }

      if (this.opportunityData && this.opportunityData.AccountID) {
        this.formData.AccountID = this.opportunityData.AccountID;
      }

      const cleanedFormData = this.normalizeFormData(this.formData);
      const backendFields = [
        'SaleID', 'AccountID', 'TipActivitateID', 'Descriere',
        'NumeFisier', 'Path', 'DataCreat', 'UserCreat', 'Globala', 'Cost',
        'Durata', 'ValutaID', 'Curs', 'Data'
      ];

      const payload: any = Object.fromEntries(
        Object.entries(cleanedFormData).filter(([key]) => backendFields.includes(key))
      );

      payload.SaleID = this.toNullIfEmpty(this.sOportunitate);
      payload.Owner = this.Username;

      try {
        // 1) salvezi activitatea
        const res = await CrmActivitati.save(payload);

        // IMPORTANT: trebuie să scoți ID-ul din răspuns
        // în OData, de obicei e res.data.ID (sau res.data.value etc.)
        const activityId = res?.data?.ID;
        if (!activityId) {
          // fallback: dacă backend-ul întoarce alt format
          console.warn("Nu am primit ID de la backend:", res?.data);
          notify('Activitate salvată, dar nu am primit ID pentru upload fișier.', 'warning', 2000);
        }

        // 2) upload fișiere dacă există
        if (activityId && this.selectedFiles && this.selectedFiles.length > 0) {
          for (const file of this.selectedFiles) {
            try {
              await CrmActivitati.uploadActivityFile(activityId, file);
            } catch (err) {
              console.error(`Error uploading file ${file.name}:`, err);
              notify(`Eroare la încărcarea fișierului ${file.name}`, 'error', 2000);
            }
          }
        }

        // UI success
        if (keepOpen !== true) {
          this.isModalVisible = false;
          notify('Activitate salvată cu succes!', 'success', 2000);
        } else {
          notify('Activitate salvată. Puteți programa acum următoarea acțiune.', 'info', 3000);
        }

        // reset
        if (keepOpen === true) {
          this.formData.Descriere = '';
          const nextDate = new Date();
          nextDate.setDate(nextDate.getDate() + 1);
          this.formData.Data = nextDate;
          this.formData.Cost = null;
          this.formData.Durata = null;
          this.formData.NumeFisier = '';
          this.formData.Path = '';
          this.selectedFile = null;
          this.selectedFiles = [];
        } else {
          this.formData = {
            Descriere: '',
            SaleID: null,
            AccountID: null,
            TipActivitateID: null,
            NumeFisier: '',
            Path: '',
            UserCreat: '',
            DataCreat: null,
            Globala: false,
            Cost: null,
            Durata: null,
            ValutaID: null,
            Curs: null,
            Data: null,
          };
          this.selectedFile = null;
          this.selectedFiles = [];
          this.sOportunitate = null;
          this.sPartener = null;
        }

        this.createODataContext();
      } catch (error) {
        console.error('Error saving activity:', error);
        notify('Eroare la salvare!', 'error', 1500);
      }

    },
    onValueSelectedPartener(e) {

      this.isParteneriGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sPartener = e.selectedRowKeys[0];

      } else {
        this.sPartener = null;
      }
      this.formData.AccountID = this.sPartener;

    },

    async onEditingStart(e: any) {
      console.log("dsTipActivitati", this.dsTipActivitati);
      console.log("dsValuta", this.dsValuta);
      console.log("tipActivitateSelectat", this.tipActivitateSelectat);
      console.log("valutaSelectat", this.valutaSelectat);

      const id = e?.data?.ID;
      this.currentEditingActivityId = id || null;

      this.editReplaceFile = null;
      this.selectedEditFile = null;
      this.editActivityFiles = [];
      this.selectedFilesEdit = [];

      if (id) await this.loadEditFiles(id);
    },


    async loadEditFiles(activityId: string) {
      try {
        this.isEditFilesLoading = true;
        const res = await CrmActivitati.list(activityId);
        this.editActivityFiles = Array.isArray(res.data) ? res.data : [];

        // opțional: selectezi default primul fișier
        this.selectedEditFile = this.editActivityFiles.length ? this.editActivityFiles[0] : null;
      } catch (err) {
        console.error(err);
        this.editActivityFiles = [];
        this.selectedEditFile = null;
        notify("Nu am putut încărca fișierele pentru editare.", "error", 1500);
      } finally {
        this.isEditFilesLoading = false;
      }
    },

    onReplaceFileSelected(e: any) {
      const files = e?.value || [];
      this.editReplaceFile = files.length ? files[0] : null;
    },

    // Custom helpers for EDIT popup
    triggerEditFileAdd() {
      const input = document.getElementById('editActivityInputHidden') as HTMLInputElement;
      if (input) input.click();
    },
    onEditFileSelectedCustom(e: Event) {
      const target = e.target as HTMLInputElement;
      const files = target.files;
      if (files && files.length > 0) {
        const newFiles = Array.from(files);
        this.selectedFilesEdit = [...this.selectedFilesEdit, ...newFiles];
        target.value = '';
      }
    },
    removeEditFile(index: number) {
      this.selectedFilesEdit.splice(index, 1);
    },

    // Custom helpers for ADD popup
    triggerAddFileSelect() {
      const input = document.getElementById('addActivityInputHidden') as HTMLInputElement;
      if (input) input.click();
    },
    onAddFileSelectedCustom(e: Event) {
      const target = e.target as HTMLInputElement;
      const files = target.files;
      if (files && files.length > 0) {
        // Append new files to existing list
        const newFiles = Array.from(files);
        this.selectedFiles = [...this.selectedFiles, ...newFiles];

        // Reset input value to allow selecting the same file again if needed
        target.value = '';
      }
    },
    removeFile(index: number) {
      this.selectedFiles.splice(index, 1);
    },


    onValueSelectedOportunitate(e) {
      this.isOportunitateGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sOportunitate = e.selectedRowKeys[0];

      } else {
        this.sOportunitate = null;
      }
      this.formData.SaleID = this.sOportunitate;

    },
    onValueSelectedTipActivitate(e) {
      this.isTipActivitateGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sTipActivitate = e.selectedRowKeys[0];

      } else {
        this.sTipActivitate = null;
      }
      this.formData.TipActivitateID = this.sTipActivitate;

    },
    onValueSelectedValuta(e) {
      this.isValuteGridBoxOpened = false;

      if (e.selectedRowKeys.length > 0) {
        this.sValuta = e.selectedRowKeys[0];

      } else {
        this.sValuta = null;
      }
      this.formData.ValutaID = this.sValuta;
    },

    onViewDetails(e) {
      const rowData = e?.row?.data;
      if (rowData) {
        this.showActivityDetails(rowData);
      }
    },
    async showActivityDetails(activity: any) {
      this.selectedActivity = {
        ...activity,
        Sale: activity.Sale?.Titlu || '-',
        Account: activity.Account?.Nume || '-',
        TipActivitate: activity.TipActivitate?.Nume || '-',
        Valuta: activity.Valuta?.Simbol || '-'
      };

      this.isActivityDetailsVisible = true;

      // IMPORTANT: așteaptă un tick ca popup-ul să fie montat (DevExtreme uneori e pretențios)
      await this.$nextTick();

      console.log("DETAILS opened for activity ID:", this.selectedActivity.ID);

      await this.loadActivityFiles(this.selectedActivity.ID);

      console.log("activityFiles after load:", this.activityFiles);
    },
    async loadActivityFiles(activityId: string) {
      try {
        this.isFilesLoading = true;
        console.log("Loading files for:", activityId);

        const res = await CrmActivitati.list(activityId);

        const data = res?.data;
        this.activityFiles = Array.isArray(data) ? data : [];

        console.log("Files API returned:", this.activityFiles.length, this.activityFiles);
      } catch (err) {
        console.error("Load files error:", err);
        this.activityFiles = [];
      } finally {
        this.isFilesLoading = false;
        console.log("isFilesLoading:", this.isFilesLoading);
      }
    },


    async onDownloadFile(file: any) {
      try {
        const res = await CrmActivitati.download(file.ID);

        // numele poate veni din API ca FileName (cum am propus)
        const fileName = file.FileName || "fisier";
        const blob = new Blob([res.data], { type: file.ContentType || "application/octet-stream" });

        // preview in tab nou (pdf/imagini) sau download
        const url = URL.createObjectURL(blob);

        // dacă vrei mereu download:
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();

        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download error:", err);
        notify("Eroare la descărcare fișier.", "error", 1500);
      }
    },



    formatDate(dateStr: string, includeTime = false) {
      if (!dateStr) return '-';
      const d = new Date(dateStr);
      if (isNaN(d.getTime())) return '-';

      const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      };

      if (includeTime) {
        options.hour = '2-digit';
        options.minute = '2-digit';
      }

      return d.toLocaleDateString('ro-RO', options);
    },
    formatCurrency(value: number, currency: string) {
      if (value === null || value === undefined) return '-';
      return new Intl.NumberFormat('ro-RO', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value) + ' ' + (currency || 'RON');
    },
    onAddClick() {
      if (this.isLocked) return;

      // Reset form data defaults
      this.formData = {
        Activitate: '',
        Descriere: '',
        Data: new Date(),
        DataDeadline: null,
        Locatie: '',
        TipActivitateID: null,
        StatusID: null,
        PrioritateID: null,
        ResursaID: null,
        Durata: null,
        IsAllDay: false,
        Email: '',
        Telefon: '',
        PersoanaContact: '',
        Cost: '0',
        ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD'
      };

      // Explicitly reset dropdown selections
      this.sTipActivitate = null;
      this.tipActivitateSelectat = [];

      this.sOportunitate = this.opportunityId;
      this.sPartener = this.accountId;
      this.formData.AccountID = this.accountId;
      this.selectedFiles = []; // Reset files
      this.isModalVisible = true;
    },
    onRefreshClick() {
      this.createODataContext();
      notify('Datele au fost actualizate cu succes!', 'success', 1000);
    },
    async SaveEdit() {
      if (this.isLocked) return;

      try {
        // 1) Salvează editarea activității (Patch OData)
        await this.$refs.dataGrid?.instance?.saveEditData();
        notify('Activitate salvată cu succes!', 'success', 1500);

        // 2) Dacă user a ales fișier nou, îl scrii pe server
        if (this.editReplaceFile && this.currentEditingActivityId) {
          if (this.editFileInfo?.ID) {
            // Replace fișier existent
            await CrmActivitati.replace(this.editFileInfo.ID, this.editReplaceFile);
          } else {
            // Upload primul fișier (dacă nu există încă)
            await CrmActivitati.upload(this.currentEditingActivityId, this.editReplaceFile);
          }

          // 3) Refresh info în UI
          await this.loadEditFile(this.currentEditingActivityId);

          // curăță selecția
          this.editReplaceFile = null;

          notify('Fișier actualizat.', 'success', 1500);
        }

        // 4) Dacă user a ales fișiere noi (UPLOAD nou)
        if (this.selectedFilesEdit.length > 0 && this.currentEditingActivityId) {
          for (const file of this.selectedFilesEdit) {
            try {
              await CrmActivitati.uploadActivityFile(this.currentEditingActivityId, file);
            } catch (err) {
              console.error(`Error uploading file ${file.name}:`, err);
              notify(`Eroare la încărcarea fișierului ${file.name}`, 'error', 2000);
            }
          }
          // refresh edit files list
          await this.loadEditFiles(this.currentEditingActivityId);
          this.selectedFilesEdit = [];
          notify('Fișiere noi adăugate.', 'success', 1500);
        }

      } catch (error) {
        console.error(error);
        notify('Eroare la salvare!', 'error', 1500);
      }
    },
    onCancel() {
      this.isModalVisible = false;
      this.$refs.dataGrid?.instance?.cancelEditData();

      // Cleanup on cancel as well
      this.selectedFiles = [];
      this.formData = {
        Activitate: '',
        Descriere: '',
        Data: new Date(),
        DataDeadline: null,
        Locatie: '',
        TipActivitateID: null,
        StatusID: null,
        PrioritateID: null,
        ResursaID: null,
        Durata: null,
        IsAllDay: false,
        Email: '',
        Telefon: '',
        PersoanaContact: '',
        Cost: '0',
        ValutaID: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD'
      };
      // Reset dropdown selections
      this.sTipActivitate = null;
      this.tipActivitateSelectat = [];
    },
    onRowRemoving() {
      notify('Datele au fost șterse cu succes!', 'success', 1000);
    },

    onExporting(e: any) {
      if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridPdf({
          jsPDFDocument: doc,
          component: e.component,
          indent: 5,
        }).then(() => {
          doc.save('CrmActivitati.pdf');
        });
      } else if (e.format === 'xlsx') {

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('activitati');

        exportDataGridExcel({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer: any) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'CrmContacts.xlsx');
          });
        });
        e.cancel = true;
      }
    },
  },

  mounted() {
    this.createODataContext();
    this.Username = JwtServices.GetUsername();
    this.setDeleteConfirmationMessage();
    loadMessages({
      "ro": {
        "Yes": "Da",
        "No": "Nu",
      }
    });

    locale('ro');
  },
});
</script>
<style scoped lang="scss">
.details-scroll-view {
  background-color: #f8f9fc;
}

.details-container {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* Header Context */
.popup-header--activity {
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
}

/* Stats Row */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.stat-card {
  background: white;
  padding: 16px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  }
}

.stat-icon {
  font-size: 24px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: #f1f5f9;
  color: #475569;
}

.stat-card--cost .stat-icon {
  background: #ecfdf5;
  color: #059669;
}

.stat-card--cost .stat-value {
  color: #059669;
}

.stat-card--duration .stat-icon {
  background: #eff6ff;
  color: #2563eb;
}

.stat-card--date .stat-icon {
  background: #fdf2f8;
  color: #db2777;
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 11px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  font-weight: 600;
}

.stat-value {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
  margin-top: 2px;
}

/* Info Sections */
.info-sections-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.info-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-section-card {
  background: white;
  border-radius: 12px;

  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-header {
  padding: 14px 16px;
  background: #fcfcfd;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  color: #334155;
  font-size: 14px;
}

.section-icon {
  color: #64748b;
  font-size: 18px;
}

.info-list {
  padding: 8px 0;
}

.info-item {
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  label {
    font-size: 11px;
    color: #94a3b8;
    text-transform: uppercase;
    font-weight: 600;
  }

  .value {
    font-size: 14px;
    color: #334155;
    font-weight: 500;

    &.multiline {
      line-height: 1.5;
      font-style: italic;
      color: #475569;
    }

    &.highlight {
      color: #2563eb;
    }

    &.success {
      color: #059669;
    }

    &.path-text {
      font-family: monospace;
      font-size: 12px;
      color: #64748b;
      word-break: break-all;
    }
  }
}


:deep(.dx-popup-content) {
  overflow: visible !important;
}

:deep(.dx-form) {
  width: 100% !important;
}

:deep(.dx-layout-manager .dx-field-item) {
  width: 100%;
}

.files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
}

.file-name {
  font-size: 13px;
  color: #334155;
  max-width: 420px;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-actions {
  display: flex;
  gap: 6px;
}


/* Status Chips */
.status-chip {
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);

  &--global {
    background: #fef3c7;
    color: #92400e;
    border-color: #fcd34d;
  }

  &--local {
    background: #f1f5f9;
    color: #475569;
    border-color: #cbd5e1;
  }
}

/* Metadata */
.system-meta-card {
  background: #f1f5f9;
  border-radius: 10px;
  padding: 12px 20px;
}

.meta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}


.files-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.file-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
}

.file-row.active {
  border-color: #ff2c21;
  background: rgba(255, 44, 33, 0.06);
}

.file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 520px;
}

.replace-block {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.replace-hint {
  font-size: 12px;
  color: #64748b;
}

.replace-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.replace-new {
  font-size: 13px;
  font-weight: 600;
  color: #059669;
}

.replace-none {
  font-size: 12px;
  color: #94a3b8;
}

.replace-actions {
  display: flex;
  justify-content: flex-end;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #64748b;
}

.meta-icon {
  font-size: 14px;
}

/* Base popup styles restored */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  color: #fff;
}

.popup-header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}


.popup-header-icon {
  font-size: 20px;
}

.popup-header-texts {
  display: flex;
  flex-direction: column;
}

.popup-header-title {
  font-size: 15px;
  font-weight: 700;
}

.popup-header-subtitle {
  font-size: 12px;
  opacity: 0.85;
}

.popup-header-meta {
  display: flex;
  align-items: center;
}

.form-content-modern {
  padding-bottom: 90px;
  /* ajustează: >= înălțimea footer-ului */
}

.footer-fixed {
  pointer-events: auto;
}

.dx-fileuploader {
  position: relative;
  z-index: 2;
}



.footer-right .dx-button {
  margin-left: 8px;
}

.footer-left .dx-button {
  margin-right: 8px;
}

.form-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.edit-file-card {
  width: 100%;
  box-sizing: border-box;
}


.edit-file-title {
  font-weight: 700;
  margin-bottom: 8px;
  color: #334155;
}

.edit-file-muted {
  color: #64748b;
  font-size: 13px;
}

.edit-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.edit-file-name {
  flex: 1;
  max-width: 620px;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.edit-file-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.popup-body-simple {
  background: white;
  padding: 20px;
}

.popup-body-modern {
  padding: 14px 18px 56px 18px;
}
</style>